import { selectAppConfig } from "./selectAppConfig";
import {SwitchType} from "../../../helpers/constants";

export const selectShowIntro = state => {
  const config = selectAppConfig(state);
  return config.blocks && config.blocks.intro ? config.blocks.intro.show : SwitchType.OFF;
}
